import type { GetStaticProps } from 'next'
import type { Project } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Hero } from '@/components/home/hero'
import { Intro } from '@/components/home/intro'
import { MarqueeBand } from '@/components/layout/marquee-band'
import { Services } from '@/components/home/services'
import { getProjects } from '@/lib/content'

interface HomeProps {
    projects: Project[]
}

export default function Home({ projects }: HomeProps) {
    return (
        <>
            <Seo
                title='Brand & Motion Designer'
                description='Elevating brand identities, systems, and apps through collaborative motion design.'
            />
            <Hero />
            <Intro projects={projects} />
            <MarqueeBand words={['WAKE UP.', 'DEVELOP.', 'REPEAT.']} />
            <Services />
        </>
    )
}

export const getStaticProps: GetStaticProps<HomeProps> = async () => {
    const projects = await getProjects()
    return { props: { projects }, revalidate: 60 }
}
